import styled from "styled-components/macro";
import Typography from "../../atoms/typography";
import media from "../../constants/MediaQuery";
import Button from "../../atoms/Button";
import { DPIconCircleRightArrow } from "../../assets/icons";
import Modal from "../../atoms/Modal";
import { BecomeAnAgentForm } from "../../atoms/BecomeAnAgentForm";
import { useState } from "react";
import Theme from "constants/Theme";
import { motion } from "framer-motion";

const EasySteps = () => {
  const [showAggregatorForm, setShowAggregatorForm] = useState(false);

  let leftVariant = {};
  let rightVariant = {};

  const isMobile = window.innerWidth < 768;

  if (!isMobile) {
    leftVariant = {
      start: { x: -50, opacity: 0 },
      end: {
        x: 0,
        opacity: 1,
        transition: {
          // delay: 0.3,
          duration: 1,
        },
      },
    };

    rightVariant = {
      start: {
        x: 300,
        opacity: 0,
      },
      end: {
        x: 0,
        opacity: 1,
        transition: {
          delay: 0.5,
          duration: 1,
        },
      },
    };
  }
  return (
    <ESS>
      <Modal
        width="max-content"
        showModal={showAggregatorForm}
        onBackdropClick={() => setShowAggregatorForm(!showAggregatorForm)}
        onCloseClick={() => setShowAggregatorForm(!showAggregatorForm)}
        maxModal
      >
        <BecomeAnAgentForm closeModal={setShowAggregatorForm} />
      </Modal>
      <div className="EasySteps__ESS__es-container container">
        <motion.img
          variants={leftVariant}
          initial="start"
          whileInView="end"
          // transition={{ delay: 0.3, duration: 1 }}
          viewport={{ once: true }}
          className="EasySteps__ESS--es-emage"
          src="./assets/images/flowSteps.png"
          alt="polsqa-emage"
        />
        <motion.div
          variants={rightVariant}
          initial="start"
          whileInView="end"
          transition={{ type: "spring", damping: 500 }}
          // transition={{ delay: 1 }}
          viewport={{ once: true }}
          className="EasySteps__ESS--become-an-agent"
        >
          <Typography.Heading
            className="landing--text-summary"
            color="pending"
            weight="medium"
            level={3}
            uppercase
            fontType="Galano"
          >
            BECOME AN AGENT
          </Typography.Heading>
          <Typography.Heading
            className="landing__heading"
            color="darkBlue"
            weight="medium"
            level={1}
            capitalize
            fontType="Galano"
            style={{
              fontSize: Theme.fontSizes.xextralarge,
            }}
          >
            4 Easy steps
          </Typography.Heading>
          <Typography.Text
            className="content-text"
            fontType="Galano Alt"
            weight="normal"
            level="large"
            color="subHeadingGrey"
            style={{
              lineHeight: "31px",
            }}
          >
            After account approval, you receive your DotPay Android POS device
            within 48hrs and can immediately start processing transactions.
          </Typography.Text>
          <Button
            className="landing-btn"
            primary
            onClick={() => setShowAggregatorForm(true)}
          >
            <Typography.Text
              uppercase
              color="white"
              weight="medium"
              level="xlarge"
            >
              Become an agent
            </Typography.Text>
            <DPIconCircleRightArrow />
          </Button>
        </motion.div>
      </div>
    </ESS>
  );
};
const ESS = styled.section`
  padding-top: 100px;
  .EasySteps__ESS {
    &__es-container {
      display: flex;
      flex-direction: column;
      ${media.tabletMin`
        flex-direction: column;
        align-items: center;
        `};
      ${media.smallDesktopMin`
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        `};
    }
    &--es-emage {
      max-width: 450px;
      width: 100%;
      ${media.smallDesktopMin`max-width: 535px;`};
    }
    &--become-an-agent {
      width: 100%;
      padding: 60px 0;
      ${media.smallDesktopMin`max-width: 436px;`};
    }
  }
`;

export default EasySteps;
